import { HttpErrorResponse } from '@angular/common/http';
import { InjectionToken } from '@angular/core';

export interface ErrorResponseHandler {
  priority: number;

  canHandle(error: HttpErrorResponse): boolean;
  buildErrorMessages(error: HttpErrorResponse): string[];
  defaultErrorMessage(): string;
}

export const ERROR_HANDLERS: InjectionToken<readonly ErrorResponseHandler[]> = new InjectionToken<
  readonly ErrorResponseHandler[]
>('ERROR_HANDLERS');
